import ListadoOrdenCompraR from "./ListadoOrdenCompraContainer";
export default ListadoOrdenCompraR;